import { useCachedSelectedProject } from 'hooks';
import { useEffect, useRef } from 'react';

export const usePollingOnError = (
  queryParams: any,
  error: any,
  refetch: any,
  data: any
) => {
  const { reportGenerating } = useCachedSelectedProject();
  const didPollOnceRef = useRef(false);
  useEffect(() => {
    const intervalMs = 4000;

    // If report generation finished, trigger a single poll to pick up final status
    if (!reportGenerating && data?.statusCode === 202) {
      if (!queryParams) return; // no active query, skip
      if (!didPollOnceRef.current) {
        refetch();
        didPollOnceRef.current = true;
      }
      return;
    }

    // While generating, reset single-poll flag and continue interval polling on 202
    didPollOnceRef.current = false;
    if (!queryParams && data?.statusCode !== 202) return; // no active query, skip
    const id = setInterval(() => {
      if (data?.statusCode === 202) {
        refetch();
      } else if (data) {
        clearInterval(id);
      }
    }, intervalMs);
    return () => clearInterval(id);
  }, [queryParams, error, data, refetch, reportGenerating]);
};
